import { useCallback, useState } from 'react'

export type TableDensity = 'compact' | 'standard'

const STORAGE_KEY = 'provisium_table_density'

const readStored = (fallback: TableDensity): TableDensity => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'compact' || stored === 'standard') return stored
  } catch {
    // localStorage недоступен
  }
  return fallback
}

/** Плотность таблицы; выбор пользователя хранится в localStorage. */
export const useTableDensity = (initial: TableDensity = 'standard') => {
  const [density, setDensityState] = useState<TableDensity>(() => readStored(initial))

  const setDensity = useCallback((next: TableDensity) => {
    setDensityState(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // localStorage недоступен
    }
  }, [])

  return { density, setDensity, tableClass: density === 'compact' ? 'market-table--compact' : '' }
}
